import { memo } from "react";

import { Text } from "@react/components/Text";
import { tw } from "classnames";

type Props = {
  bundleReviewsDisclaimer: string;
  bundleValueDisclaimer: string;
  showCompareAtPriceValueFootnote: boolean;
  showReviewsFootnote: boolean;
};

const styles = {
  base: tw("text-tertiary"),
};

const FootnotesViewBase = ({
  bundleReviewsDisclaimer,
  bundleValueDisclaimer,
  showCompareAtPriceValueFootnote,
  showReviewsFootnote,
}: Props) => {
  return (
    <>
      {showReviewsFootnote && (
        <Text as="caption" className={styles.base} size="xs">
          * {bundleReviewsDisclaimer}
        </Text>
      )}
      {showCompareAtPriceValueFootnote && (
        <Text as="caption" className={styles.base} size="xs">
          † {bundleValueDisclaimer}
        </Text>
      )}
    </>
  );
};

export const FootnotesView = memo(FootnotesViewBase);
